import React, { Component } from "react";
import styled from 'styled-components';
import { connect } from "react-redux";
import { rental } from "../../../operations";
import { Button } from '../../ui';
import Loader from '../../Common/Loader';
import {
  clean,
  showError,
  setRentalValue,
  increaseStepByOne
} from "../../../actions";
import { Title, Body } from '../../Common/Form';
import Text from '../../Common/Form/Text';
import buildingsImage from '../../../assets/gtiaAlquiler/buildings.png';
import { numberWithDots, justNumbers } from '../../../helpers';
import Checkbox from './Checkbox';
import Input from './Input'; // TODO: Este es un Input especial y no es el mismo que esta en UI

const RentalWrapper = styled.div`
  .GtiaValueDivContainer {
    font-size: 16px;

    hr {
      box-sizing: content-box;
      height: 0;
      overflow: visible;
      margin-bottom: 2rem;
      border: 0;
      border-top: 1px solid rgba(0,0,0,.1);
    }

    .GtiaValueLabel {
      display: block;
      margin-bottom: .5rem;
      color: var(--blue-color);
      font-weight: 500;
    }
  }

  .GtiaFooter {
    font-size: 12px !important;
  }

  .Rental-buttonWrapper {
    font-size: 10px;
    margin-top: 30px;

    .Rental-button {
      min-width: 0;
      padding-left: 3rem !important;
      padding-right: 3rem !important;
    }
  }
`;

const ButtonsGroup = styled.div`
  text-align: center;
  font-size: 8px !important;

  > * + * {
    margin-left: 1rem;
  }

  .noMinWidth {
    min-width: 0;
    padding-left: 2rem !important;
    padding-right: 2rem !important;
  }
`;

const CheckboxesGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3rem !important;

  > * + * {
    margin-left: 3rem !important;
  }
`;

const TextLabel = styled.div`
  font-size: 16px !important;
  line-height: 1.5  !important;
  font-weight: 900;
  text-align: center;
  color: var(--grey-color);
  margin-top: 1rem;
`;

class AlquilerForm extends Component {
  constructor(props) {
    super(props);

    this.getLeftColumnContent = this.getLeftColumnContent.bind(this);
    this.getRightColumnContent = this.getRightColumnContent.bind(this);
  }

  handleJustNumbersChange = (name, value) => {
    const { onValueChange } = this.props;

    if (justNumbers(value)) {
      onValueChange(name, value);
    }
  }

  simulateCondition() {
    const { amount, currencyCode, isCompany } = this.props;

    if (isCompany) {
      return (
        amount &&
        amount !== '' &&
        amount > 0 &&
        (
          (!currencyCode && amount <= 120000)
          ||
          (currencyCode && amount <= 4000)
        )
      );
    } else {
      return (
        amount &&
        amount !== '' &&
        amount > 0 &&
        (
          (!currencyCode && amount <= 60000)
          ||
          (currencyCode && amount <= 2050)
        )
      );
    }
  }

  getLeftColumnContent() {
    const {
      onValueChange,
      isCompany,
      error,
      getQuotation,
      restart,
      prize,
      amount,
      currencyCode,
    } = this.props;

    return (
      <div>
        <Checkbox
          id="isCompany"
          onChange={(event) => { onValueChange('isCompany', event.target.checked) }}
          checked={isCompany}
          label="Es una empresa"
        />

        <div style={{ margin: '40px 0 0 0' }}>
          <Input
            placeholder="Ingrese el importe"
            label="Importe del Alquiler mensual"
            type="phone"
            name="amount"
            value={amount}
            className="Input--medium"
            id="amount"
            onChange={(event) => {
              this.handleJustNumbersChange('amount', event.target.value);
            }}
          />
        </div>

        {this.errorMessage(!isCompany && !currencyCode && parseInt(amount, 10) > 60000, '$ 60.000')}
        {this.errorMessage(!isCompany && currencyCode && parseInt(amount, 10) > 2050, 'U$S 2.050')}
        {this.errorMessage(isCompany && !currencyCode && parseInt(amount, 10) > 120000, '$ 120.000')}
        {this.errorMessage(isCompany && currencyCode && parseInt(amount, 10) > 4000, 'U$S 4.000')}

        <div style={{ marginTop: 40 }}>
          <CheckboxesGroup>
            <Checkbox
              id="currencyCodePeso"
              onChange={() => { onValueChange('currencyCode', false) }}
              checked={!currencyCode}
              label="Pesos"
            />

            <Checkbox
              id="currencyCodeDolar"
              onChange={() => { onValueChange('currencyCode', true) }}
              checked={currencyCode}
              label="Dólares"
            />
          </CheckboxesGroup>
        </div>

        <ButtonsGroup>
          <Button
            className="noMinWidth"
            disabled={this.simulateCondition() ? false : true}
            onClick={this.simulateCondition() ? getQuotation : showError}
          >
            Simular
          </Button>

          <Button
            className="noMinWidth"
            secondary
            onClick={restart}
          >
            Limpiar
          </Button>
        </ButtonsGroup>

        <div className="Purchase-Image-Rental-Small">
          {prize && prize > 0 ? this.getBuildingsImage() : null}
        </div>
      </div>
    );
  }

  getRightColumnContent() {
    const {
      innerLoading,
      prize,
      prize6,
      prize10,
      fixedAmount,
      minSalary,
      nextStep
    } = this.props;

    return (
      <div>
        {innerLoading ? <Loader message='' /> :
          <div>
          {(!prize || prize === 0) ? this.getBuildingsImage() :
            <RentalWrapper>
              <div className="GtiaValueDivContainer">
                {this.getValueDiv('Importe del alquiler', fixedAmount, 1, 3)}
                {this.getValueDiv('Ingresos Necesarios mensuales', minSalary, 1, 3)}
                {this.getValueDiv('Costo Anual', prize, 1, 1)}
                {this.getValueDiv('Contado', prize, 2, 2)}
                {this.getValueDiv('6 cuotas (*)', prize6, 1, 1)}
                {this.getValueDiv('10 cuotas (**)', prize10, 2, 2)}
              </div>

              <div className="GtiaFooter">
                (*) sin recargo con tarjeta de crédito <br/>
                (**) no incluye recargo aplicado por tarjeta de crédito <br/>
                El pago en cuotas se podrá realizar únicamente a través de tarjeta de crédito
              </div>

              <div className="Rental-buttonWrapper">
                <Button
                  className="Rental-button"
                  onClick={nextStep}
                >
                  Solicitar garantía
                </Button>
              </div>
            </RentalWrapper>
          }
          </div>
        }
      </div>
    );
  }

  getBuildingsImage = () => {
    return (
      <div>
        <div className="Purchase-Image-Container-Rental" style={{ marginBottom: 30 }}>
          <img className="Purchase-Image-Rental" src={buildingsImage} alt="buildingsImage" />
        </div>
      </div>
    );
  }

  getValueDiv(message, amount, start = 1, end = 2){
    return (
      <div className="GtiaValueDiv" style={{ 'gridColumnStart': start, 'gridColumnEnd': end }}>
        <label className="GtiaValueLabel">
          {message}
        </label>
        <div className="GtiaValueAmount">
          {this.currSign() + numberWithDots(amount)}
        </div>
        <hr className="GtiaHr"/>
      </div>
    );
  }

  currSign() {
    const { fixedCurrencyCode } = this.props;
    return fixedCurrencyCode ? 'U$S ' : '$ ';
  }

  errorMessage(condition, value) {
    const { error } = this.props;

    // if (error && condition) {
    if (condition) {
      return (
        <div className="ErrorMessageRental" style={{ color: 'firebrick', fontSize: 14, marginTop: 5 }}>
          {`El importe debe ser menor a ${value}`}
        </div>
      );
    }
  }

  render() {
    return (
      <>
        <Text className="Text-question" style={{ marginBottom: 40 }}>
          ¡Cotiza aquí tu Seguro de Garantía de Alquiler!
        </Text>

        <Body
          leftColumnContent={this.getLeftColumnContent}
          rightColumnContent={this.getRightColumnContent}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    error: state.steps.showError,
    innerLoading: state.steps.isInnerLoading,

    amount: state.rental.amount,
    isCompany: state.rental.isCompany,
    currencyCode: state.rental.currencyCode,

    fixedAmount: state.rental.fixedAmount,
    fixedCurrencyCode: state.rental.fixedCurrencyCode,

    prize: state.rental.prize,
    prize6: state.rental.prize6,
    prize10: state.rental.prize10,
    minSalary: state.rental.minSalary,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    restart: () => {
      dispatch(clean());
    },
    nextStep: () => {
      dispatch(increaseStepByOne());
    },
    onValueChange: (type, value) => {
      dispatch(setRentalValue(type, value));
    },
    getQuotation: () => {
      dispatch(showError(false));
      dispatch(rental.getQuotation());
    },
    showError: () => {
      dispatch(showError(true));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlquilerForm);
